// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3UMB0","removeAction":"removeAction--2rK8_"};